var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationnUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Location & User Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "globe-solid",
    d: "M16.5,12a29.311,29.311,0,0,1-.155,3H7.655A28.034,28.034,0,0,1,7.5,12a29.31,29.31,0,0,1,.155-3h8.691A28.034,28.034,0,0,1,16.5,12Zm1.35-3h5.77a12.042,12.042,0,0,1,0,6H17.85A29.616,29.616,0,0,0,18,12,29.616,29.616,0,0,0,17.85,9Zm5.278-1.5h-5.47A16.488,16.488,0,0,0,15.066.394,12.023,12.023,0,0,1,23.123,7.5Zm-6.989,0H7.861A18.892,18.892,0,0,1,9.127,3.061,7.657,7.657,0,0,1,10.7.647,1.937,1.937,0,0,1,12,0a1.937,1.937,0,0,1,1.3.647,7.657,7.657,0,0,1,1.57,2.414A18.329,18.329,0,0,1,16.139,7.5Zm-9.8,0H.872A12.031,12.031,0,0,1,8.934.394,16.488,16.488,0,0,0,6.342,7.5ZM.38,9H6.15a30.075,30.075,0,0,0,0,6H.38a12.042,12.042,0,0,1,0-6ZM9.127,20.934A18.565,18.565,0,0,1,7.861,16.5h8.278a18.784,18.784,0,0,1-1.266,4.434,7.657,7.657,0,0,1-1.57,2.414A1.926,1.926,0,0,1,12,24a1.937,1.937,0,0,1-1.3-.647,7.657,7.657,0,0,1-1.57-2.414ZM6.342,16.5a16.488,16.488,0,0,0,2.592,7.106A12.031,12.031,0,0,1,.872,16.5Zm16.786,0a12.033,12.033,0,0,1-8.058,7.106A16.548,16.548,0,0,0,17.663,16.5h5.466Z",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationnUser);
export default __webpack_public_path__ + "static/media/locationnUser.ba134adc33e64cf17ab980ff8693084c.svg";
export { ForwardRef as ReactComponent };